module.exports = __webpack_public_path__ + "assets/retina_GeometricMeanDetailed.1332cd817460b7cb5188e70368a287d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_GeometricMeanDetailed.png
// module id = 669
// module chunks = 0